export const LOAD_QUIZLIST  = 'LOAD_QUIZLIST'
export const LOAD_QUIZLIST_ERROR  = 'LOAD_QUIZLIST_ERROR'

export const LOAD_QUIZ_BY_ID  = 'LOAD_QUIZ_BY_ID'
export const LOAD_QUIZ_ERROR  = 'LOAD_QUIZ_ERROR'
export const CHECK_SOLUTION  = 'CHECK_SOLUTION'
